import React from "react";
import { ReactComponent as DropIcon } from "./../../images/svg/drop.svg";
import { gettext, cropr } from "../../adapter";
import moment from "moment";
import battery0 from "./../../images/batt_0.png";
import battery1 from "./../../images/batt_1.png";
import battery2 from "./../../images/batt_2.png";
import battery3 from "./../../images/batt_3.png";
import battery4 from "./../../images/batt_4.png";
import battery5 from "./../../images/batt_5.png";
import signal0 from "./../../images/sig_0.png";
import signal1 from "./../../images/sig_1.png";
import signal2 from "./../../images/sig_2.png";
import signal3 from "./../../images/sig_3.png";
import signal4 from "./../../images/sig_4.png";
import signal5 from "./../../images/sig_5.png";

const Information = ({ sensor, lastDataPoint, stateText }) => {
  var precision = cropr.l10n.unit_precipitation === "in" ? 1 : 0;

  var status = <span>-</span>;
  if (sensor.status === "new") {
    status = (
      <span>
        <DropIcon className="icon text-gray is-inline" />
        {gettext("Not yet configured")}
      </span>
    );
  } else if (sensor.period === "past") {
    status = (
      <span>
        <DropIcon className="icon text-gray is-inline" />
        {gettext("Measurement period in the past")}
      </span>
    );
  } else if (sensor.period === "future") {
    status = (
      <span>
        <DropIcon className="icon text-gray is-inline" />
        {gettext("Measurement period in the future")}
      </span>
    );
  } else if (sensor.status === "onNoData") {
    status = (
      <span>
        <DropIcon className="icon text-gray is-inline" />
        {gettext("No data")}
      </span>
    );
  } else if (sensor.soilMoistureStatus === "aboveFieldCapacity") {
    status = (
      <span>
        <DropIcon className="icon text-blue is-inline" />
        {gettext("Above field capacity")}
      </span>
    );
  } else if (sensor.soilMoistureStatus === "belowRefillPoint") {
    status = (
      <span>
        <DropIcon className="icon text-red is-inline" />
        {gettext("Below refill point")}
      </span>
    );
  } else if (sensor.soilMoistureStatus === "belowWarningPoint") {
    status = (
      <span>
        <DropIcon className="icon text-yellow is-inline" />
        {gettext("Below warning point")}
      </span>
    );
  } else if (sensor.soilMoistureStatus === "normal") {
    status = (
      <span>
        <DropIcon className="icon text-green is-inline" />
        {gettext("Normal moisture status")}
      </span>
    );
  }

  var lastUpdate = "-";
  if (lastDataPoint && lastDataPoint.timestamp) {
    lastUpdate = moment(lastDataPoint.timestamp).format(
      gettext("dddd D MMMM YYYY [at] HH:mm [hour]")
    );
  }

  // Format soil moisture values
  var soilMoisture = "-";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.soilMoisture || sensor.soilMoisture === 0)
  ) {
    soilMoisture =
      cropr.toLocaleFixed(cropr.l10n_utils.mm_to_l10n(sensor.soilMoisture), precision) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  // Format soil refill capacity values
  var refillCapacity = "-";
  if (
    sensor.period === "now" &&
    sensor.status !== "onNoData" &&
    (sensor.refillCapacity || sensor.refillCapacity === 0)
  ) {
    refillCapacity =
      cropr.toLocaleFixed(cropr.l10n_utils.mm_to_l10n(sensor.refillCapacity), precision) +
      " " +
      cropr.l10n.unit_precipitation_display;
  }

  var voltagelink = "-";
  var voltage = "-";
  if (sensor.voltage) {
    if (sensor.voltage < 3.7) {
      voltage = battery1;
    } else if (sensor.voltage < 3.9) {
      voltage = battery2;
    } else if (sensor.voltage < 4.1) {
      voltage = battery3;
    } else if (sensor.voltage < 4.3) {
      voltage = battery4;
    } else if (sensor.voltage >= 4.3) {
      voltage = battery5;
    } else voltage = battery0;
    voltagelink = <img alt="" src={voltage} width="30px" />;
  }

  if (sensor.battery) {
    if (sensor.battery < 20) {
      voltage = battery1;
    } else if (sensor.battery < 40) {
      voltage = battery2;
    } else if (sensor.battery < 60) {
      voltage = battery3;
    } else if (sensor.battery < 80) {
      voltage = battery4;
    } else if (sensor.battery >= 80) {
      voltage = battery5;
    } else voltage = battery0;
    voltagelink = <img alt="" src={voltage} width="30px" />;
  }

  var csq = "-";
  var csqlink = "-";
  if (sensor.csq) {
    if (sensor.csq < 8 || sensor.csq >= 52) {
      csq = signal0;
    } else if (sensor.csq < 13) {
      csq = signal1;
    } else if (sensor.csq < 18) {
      csq = signal2;
    } else if (sensor.csq < 23) {
      csq = signal3;
    } else if (sensor.csq < 28) {
      csq = signal4;
    } else if (sensor.csq < 52) {
      csq = signal5;
    } else csq = signal0;
    csqlink = <img alt="" src={csq} width="30px" />;
  }

  if (sensor.rssi) {
    if (sensor.rssi < 20) {
      csq = signal1;
    } else if (sensor.rssi < 40) {
      csq = signal2;
    } else if (sensor.rssi < 60) {
      csq = signal3;
    } else if (sensor.rssi < 80) {
      csq = signal4;
    } else if (sensor.rssi >= 80) {
      csq = signal5;
    } else csq = signal0;
    csqlink = <img alt="" src={csq} width="30px" />;
  }

  var serialNumber = gettext("Unknown");
  if (sensor.serialNumber) {
    serialNumber = sensor.serialNumber;
  }

  var soilType = gettext("Unknown");
  switch (sensor.soilType) {
    case "01":
      soilType = gettext("Sand");
      break;
    case "02":
      soilType = gettext("Sandy loam");
      break;
    case "03":
      soilType = gettext("Loamy sand");
      break;
    case "04":
      soilType = gettext("Silt");
      break;
    case "05":
      soilType = gettext("Sandy loam (humic)");
      break;
    case "06":
      soilType = gettext("Loam");
      break;
    case "07":
      soilType = gettext("Sandy clay loam ");
      break;
    case "08":
      soilType = gettext("Sandy clay loam");
      break;
    case "09":
      soilType = gettext("Clay");
      break;
    case 10:
      soilType = gettext("Peaty clay");
      break;
    case "11":
      soilType = gettext("Cleayey peat");
      break;
    case 12:
      soilType = gettext("Peat");
      break;
    case 13:
      soilType = gettext("Loamy sand, humic");
      break;
    case 14:
      soilType = gettext("Fine loamy sand, humic");
      break;
    case 15:
      soilType = gettext("Silty loam");
      break;
    default:
      soilType = gettext("Unknown");
  }

  return (
    <div>
      <h2>{gettext("Current status")}</h2>
      <dl className="is-advanced has-large-spacing">
        <dt>{gettext("Type")}:</dt>
        <dd>{sensor.type}</dd>
        <dt>{gettext("Serial number")}:</dt>
        <dd>{serialNumber}</dd>
        <dt>{gettext("Status")}:</dt>
        <dd>{status}</dd>
        <dt>{gettext("Sensor status")}:</dt>
        <dd>{stateText}</dd>
      </dl>
      <dl className="is-advanced has-large-spacing">
        <dt>{gettext("Soil type")}:</dt>
        <dd>{soilType}</dd>
        <dt>{gettext("Latest update")}:</dt>
        <dd>{lastUpdate}</dd>
        <dt>{gettext("Available soil moisture")}:</dt>
        <dd>{soilMoisture}</dd>
        <dt>{gettext("Refill capacity")}:</dt>
        <dd>{refillCapacity}</dd>
      </dl>
      <dl className="is-advanced has-small-spacing">
        <dt>{gettext("Carrier signal strength")}:</dt>
        <dd>{csqlink}</dd>
        <dt>{gettext("Voltage")}:</dt>
        <dd>{voltagelink}</dd>
      </dl>
    </div>
  );
};

export default Information;
